// import 'vue-class-component/hooks'
import Vue from 'vue'
import '@/mixins/global'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import '@/styles/index.less'
// import 'ant-design-vue/dist/antd.less';

import App from './App.vue'
import store from './store'
import router from './router'

import './routeGuard' // permission control
import * as echarts from 'echarts'
import * as filters from './filters' // global filters

import '@/utils/drag.js'

// register global utility filters
Object.keys(filters).forEach(key => {
  // @ts-ignore
  Vue.filter(key, filters[key])
})
Vue.prototype.$echarts = echarts
import './antd' // ant-design-vue 按需引入
import './components'
import './components/index'
import './layout/index'

import i18n from './locales'
import './utils/filter'
import masterlinkUI from 'master-link-ui'
// Vue.use(masterlinkUI)
Vue.component('ml-directory', masterlinkUI.MLDirectory)
// bus实例
const eventBus = {
  install(Vue: any) {
    Vue.prototype.$bus = new Vue()
  },
}
Vue.use(eventBus)

import './directives/acl'
import './directives/draggable'
import './directives/selected'
import './directives/resize'
import './directives/infinite-scroll/index'

import waterfall from 'vue-waterfall2'

Vue.use(waterfall)

import vcolorpicker from 'vcolorpicker'
Vue.use(vcolorpicker)

import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

import CollapseView from '@/components/CollapseView/index'

Vue.component('CollapseView', CollapseView)

import { Chrome } from 'vue-color'
Vue.component('chrome-picker', Chrome)
import vueDraggableResizable from 'vue-draggable-resizable'
Vue.component('vue-draggable-resizable', vueDraggableResizable)

import VueCompositionApi from '@vue/composition-api'
Vue.use(VueCompositionApi)
import dragModal from '@/components/DragModal'
Vue.use(dragModal)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
